import React, { ForwardedRef, forwardRef, useId, useState } from "react";
import classNames from "classnames";
import { SVVFormError } from "./FormError";
import { SelectProps } from "./typer";
import {Description} from "./Description";
import {SVVLabel} from "./Label";

function Component(
  {
    selected,
    options,
    legend,
    emptyChoiceText,
    id,
    errorMessage,
    required,
    selectSize,
    popoverText,
    popoverTitle,
    removeMargin = false,
    isFullWidth = false,
    description,
    ...rest
  }: SelectProps,
  ref: ForwardedRef<HTMLSelectElement>,
) {
  const [errorMessageId] = useState(`errormessage-${useId()}`);

  const cssClass = classNames("svv-form-input__select", {
    "input--x-small": selectSize === "xSmall",
    "input--small": selectSize === "small",
    "input--medium": selectSize === "medium",
    "svv-form-input__text--error": errorMessage,
  });

  return (
    <div
      className={classNames(
        "svv-form-element",
        {
          "svv-form-element--max-width": !isFullWidth,
          "svv-form-element--margin-bottom": !removeMargin,
        })}
    >
      <SVVLabel
        htmlFor={id}
        popoverTitle={popoverTitle}
        popoverText={popoverText}
        required={required}
      >
        {legend}
      </SVVLabel>
      {description &&
        <Description content={description}/>
      }
      <select
        name="bestill-for"
        id={id}
        value={selected}
        aria-describedby={errorMessage ? errorMessageId : undefined}
        required={required}
        ref={ref}
        {...rest}
        {...(errorMessage && { className: "svv-form-input__text--error" })}
        {...(cssClass && { className: cssClass })}
      >
        {emptyChoiceText && <option value="">{emptyChoiceText}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value} {...(o.disabled && { disabled: true })}>
            {o.text}
          </option>
        ))}
      </select>
      {errorMessage && <SVVFormError id={errorMessageId}>{errorMessage}</SVVFormError>}
    </div>
  );
}

export const SVVSelect = forwardRef<HTMLSelectElement, SelectProps>(Component);

SVVSelect.displayName = "SVVSelect";
